/**
 * Roles API - uses Axios apiClient with auth interceptors.
 * authorization-role and authorization-resource are injected by the request interceptor from authStore.
 */
import { apiClient } from "features/shared/api/axiosInstance";
import type { AssignRoleRequest } from "common/models/api/models/AssignRoleRequest";

export const rolesApi = {
    assignRole: (body: AssignRoleRequest) => apiClient.post("/api/roles/assign", body),
    updateRole: (body: AssignRoleRequest) => apiClient.put("/api/roles", body),
    deleteRole: (body: AssignRoleRequest) => apiClient.delete("/api/roles", { data: body }),
};
